module.exports = __webpack_public_path__ + "static/media/bg.21378306.png";